import React from 'react';
import {
  CustomerFeedback,
  CmsComponentBaseProps,
  CustomerFeedbackPayload,
} from '@johnlewispartnership/wtr-content-component-library';

import { submitCustomerFeedback } from 'redux/modules/customer-feedback/actions';
import { useWtrDispatch } from 'redux/hooks';

const CustomerFeedbackWrapper = (props: CmsComponentBaseProps) => {
  const dispatch = useWtrDispatch();
  const onSubmit = (payload: CustomerFeedbackPayload) => dispatch(submitCustomerFeedback(payload));

  return <CustomerFeedback onSubmit={onSubmit} {...props} />;
};

export default CustomerFeedbackWrapper;
